import React, { useState, useEffect } from 'react';
import { branchesAPI } from '../../utils/api';
import { FaPlus, FaEdit, FaTrash, FaSearch, FaTimes } from 'react-icons/fa';
import '../../styles/AdminBranches.css';

const AdminBranches = () => {
    const [branches, setBranches] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [editingBranch, setEditingBranch] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [message, setMessage] = useState({ type: '', text: '' });

    const [formData, setFormData] = useState({
        name: '',
        gln: '',
        partner_code: ''
    });

    useEffect(() => {
        loadBranches();
    }, []);

    const loadBranches = async () => {
        setLoading(true);
        try {
            const res = await branchesAPI.getBranches();
            setBranches(res.data.data);
        } catch (error) {
            console.error('Ошибка загрузки филиалов:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleOpenModal = (branch = null) => {
        if (branch) {
            setEditingBranch(branch);
            setFormData({
                name: branch.name,
                gln: branch.gln,
                partner_code: branch.partner_code
            });
        } else {
            setEditingBranch(null);
            setFormData({ name: '', gln: '', partner_code: '' });
        }
        setShowModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ type: '', text: '' });

        try {
            if (editingBranch) {
                await branchesAPI.updateBranch(editingBranch._id, formData);
                setMessage({ type: 'success', text: 'Филиал обновлен' });
            } else {
                await branchesAPI.createBranch(formData);
                setMessage({ type: 'success', text: 'Филиал создан' });
            }
            setShowModal(false);
            loadBranches();
        } catch (error) {
            setMessage({
                type: 'error',
                text: error.response?.data?.message || 'Ошибка сохранения филиала'
            });
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Вы уверены, что хотите удалить этот филиал?')) return;

        try {
            await branchesAPI.deleteBranch(id);
            setMessage({ type: 'success', text: 'Филиал удален' });
            loadBranches();
        } catch (error) {
            setMessage({
                type: 'error',
                text: error.response?.data?.message || 'Ошибка удаления филиала'
            });
        }
    };

    const filteredBranches = branches.filter(branch => {
        if (!searchQuery) return true;
        const query = searchQuery.toLowerCase();
        return (
            branch.name?.toLowerCase().includes(query) ||
            branch.gln?.toLowerCase().includes(query) ||
            branch.partner_code?.toLowerCase().includes(query)
        );
    });

    return (
        <div className="admin-branches-page">
            <div className="admin-branches-header">
                <h1>Клиенты Telema</h1>
                <button onClick={() => handleOpenModal()} className="btn-add">
                    <FaPlus /> Добавить клиента
                </button>
            </div>

            {message.text && (
                <div className={`message ${message.type}`}>{message.text}</div>
            )}

            <div className="branches-controls">
                <div className="search-box">
                    <FaSearch className="search-icon" />
                    <input
                        type="text"
                        placeholder="Поиск по названию, GLN или коду партнера..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="branch-search-input"
                    />
                    {searchQuery && (
                        <button
                            onClick={() => setSearchQuery('')}
                            className="clear-search-btn"
                            title="Очистить поиск"
                        >
                            <FaTimes />
                        </button>
                    )}
                </div>
                {searchQuery && (
                    <div className="search-results-info">
                        Найдено: {filteredBranches.length} из {branches.length}
                    </div>
                )}
            </div>

            {loading ? (
                <div className="loading">Загрузка...</div>
            ) : filteredBranches.length === 0 ? (
                <div className="no-results">
                    {searchQuery ? (
                        <>
                            <p>Филиалы не найдены по запросу "{searchQuery}"</p>
                            <button onClick={() => setSearchQuery('')} className="btn-secondary">
                                Очистить поиск
                            </button>
                        </>
                    ) : (
                        <p>Нет зарегистрированных филиалов</p>
                    )}
                </div>
            ) : (
                <div className="branches-table-wrapper">
                    <table className="branches-table">
                        <thead>
                            <tr>
                                <th>Название</th>
                                <th>GLN Код</th>
                                <th>Код партнера</th>
                                <th>Действия</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredBranches.map(branch => (
                                <tr key={branch._id}>
                                    <td className="branch-name">{branch.name}</td>
                                    <td className="branch-gln">{branch.gln}</td>
                                    <td className="branch-code">{branch.partner_code}</td>
                                    <td className="branch-actions">
                                        <button onClick={() => handleOpenModal(branch)} className="btn-icon" title="Редактировать">
                                            <FaEdit />
                                        </button>
                                        <button onClick={() => handleDelete(branch._id)} className="btn-icon delete" title="Удалить">
                                            <FaTrash />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}

            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h2>{editingBranch ? 'Редактировать клиента' : 'Новый клиент Telema'}</h2>
                            <button onClick={() => setShowModal(false)} className="modal-close">×</button>
                        </div>

                        <form onSubmit={handleSubmit} className="branch-form">
                            <div className="form-group">
                                <label>Название (Filiaal) *</label>
                                <input
                                    type="text"
                                    value={formData.name}
                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                    required
                                    placeholder="Название филиала"
                                />
                            </div>

                            <div className="form-group">
                                <label>GLN Код *</label>
                                <input
                                    type="text"
                                    value={formData.gln}
                                    onChange={(e) => setFormData({ ...formData, gln: e.target.value })}
                                    required
                                    placeholder="GLN код (13 цифр)"
                                />
                            </div>

                            <div className="form-group">
                                <label>Код партнера (Link) *</label>
                                <input
                                    type="text"
                                    value={formData.partner_code}
                                    onChange={(e) => setFormData({ ...formData, partner_code: e.target.value })}
                                    required
                                    placeholder="Код партнера"
                                />
                            </div>

                            <div className="form-actions">
                                <button type="submit" className="btn-primary">
                                    {editingBranch ? 'Сохранить изменения' : 'Создать'}
                                </button>
                                <button type="button" onClick={() => setShowModal(false)} className="btn-secondary">
                                    Отмена
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminBranches;
